import '../styles/ActionCards.css';

const CARDS = [
  {
    title: 'Delegate & Stake',
    image: 'delegate-stake.webp',
    body: "A simple and effective way of boosting rewards while contributing to Flare's security",
    href: 'https://flare.network/delegate-and-stake',
  },
  {
    title: 'Vote',
    image: 'vote.webp',
    body: 'Participate in transparent, onchain governance to define the future of Flare',
    href: 'https://flare.network/vote',
  },
  {
    title: 'Community',
    image: 'community.webp',
    body: 'Come together, share ideas, and build',
    href: 'https://flare.network/community',
  },
  {
    title: 'Developer Resources',
    image: 'developer-resources.webp',
    body: 'The decentralized origin for Flare builders',
    href: 'https://flare.network/resources/developer-hub',
  },
];

function ActionCards() {
  return (
    <section className="action-cards">
      <div className="action-cards__grid">
        {CARDS.map((card) => (
          <a href={card.href} className="action-card" key={card.title}>
            <img
              src={`${process.env.PUBLIC_URL}/images/${card.image}`}
              alt={card.title}
              className="action-card__image"
            />
            <h3 className="action-card__title">
              {card.title} <span className="action-card__arrow">→</span>
            </h3>
            <p className="action-card__body">{card.body}</p>
          </a>
        ))}
      </div>
    </section>
  );
}

export default ActionCards;